"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataValidation = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const look_up_entity_1 = require("./look-up.entity");
const task_entity_1 = require("./task.entity");
const opportunity_data_validation_document_map_entity_1 = require("./opportunity-data-validation-document-map.entity");
let DataValidation = class DataValidation {
    constructor(
    // planDate: Date,
    // performDate: Date,
    description, 
    // activityTypeLid: number,
    taskId, statusLid) {
        // this.planDate = planDate;
        // this.performDate = performDate;
        this.description = description;
        // this.activityTypeLid = activityTypeLid;
        this.taskId = taskId;
        this.statusLid = statusLid;
    }
};
exports.DataValidation = DataValidation;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], DataValidation.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], DataValidation.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], DataValidation.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], DataValidation.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "description", type: "text" }),
    tslib_1.__metadata("design:type", String)
], DataValidation.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamp" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], DataValidation.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamp" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], DataValidation.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], DataValidation.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], DataValidation.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], DataValidation.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "task_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], DataValidation.prototype, "taskId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp, (lookup) => lookup.id),
    (0, typeorm_1.JoinColumn)({ name: "status_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _c : Object)
], DataValidation.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => task_entity_1.Task),
    (0, typeorm_1.JoinColumn)({ name: "task_id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _d : Object)
], DataValidation.prototype, "task", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_data_validation_document_map_entity_1.OpportunityDataValidationDocumentMap, (dataValidationDoc) => dataValidationDoc.dataValidation),
    tslib_1.__metadata("design:type", Array)
], DataValidation.prototype, "dataValidationDocs", void 0);
exports.DataValidation = DataValidation = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_data_validation"),
    tslib_1.__metadata("design:paramtypes", [String, Number, Number])
], DataValidation);
